import device from "src/styles/device";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  /* max-width: 1240px; */
  position: relative;
  padding: 20px;
  /* padding: 24px 70px 80px; */
  /* margin: auto; */

  & > div > p {
    word-wrap: break-word;
  }

  @media ${device.mobileL} {
    padding: 16px;
  }
`;

const Content = ({ children }) => {
  return <Container>{children}</Container>;
};

export default Content;
